import styles from './css/clientsCmvList.module.css';
import useWindowSize from "../../../../hooks/useWindowSize";




export default function ClientsCmvList({ clients, openUser }) {
    const width = useWindowSize();
    const isDesktop = width >= 1280;

    function formatName(name) {
        return name.length > 15 ? `${name.slice(0, 12)}...` : name;
    }

    if (isDesktop) {
        // ---- RENDERIZA A TABELA NORMAL ----
        return (
            <div className={styles.companiesListArea}>

                {/* ---------- VISUAL DESKTOP (≥1280px) ---------- */}
                {isDesktop && (
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: 100 }}></th>
                                <th className={styles.tableHeader}>Usuário</th>
                                <th className={styles.tableHeader}>Email</th>
                                <th className={styles.tableHeader}>CPF</th>
                                <th className={styles.tableHeader}>Telefone</th>
                                <th className={styles.tableHeader}>Em teste</th>
                                <th className={styles.tableHeader}>Pagamento</th>
                                <th className={styles.tableHeader}>Prox. Pagamento</th>
                                <th className={styles.tableHeader}>Registro</th>
                            </tr>
                        </thead>

                        <tbody>
                            {clients.map((item) => {
                                const paymentControl = item.payment_control ?? null;
                                const paymentStatus = {
                                    background: paymentControl?.status ? "green" : "red",
                                    color: "#fff",
                                    text: paymentControl?.status ? "Realizado" : "Inadimplente",
                                };
                                const nextPayment = paymentControl?.next_payment
                                    ? new Date(paymentControl.next_payment).toLocaleDateString()
                                    : "Sem dados";
                                const overdue = paymentControl?.next_payment && new Date(paymentControl.next_payment) < new Date();

                                const trial = item.trial;
                                const trialStatus = trial
                                    ? {
                                        background: trial?.status ? 'green' : 'orange',
                                        color: "#fff",
                                        text: trial?.status ? 'Ativo' : 'Expirado',
                                    }
                                    : {
                                        background: 'transparent',
                                        color: "#333",
                                        text: 'Sem trial',
                                    };

                                return (
                                    <tr key={item.id} className={styles.lineTableCels}>
                                        <td className={styles.tableData}>
                                            <button
                                                className={styles.editButton}
                                                onClick={() => openUser({ id: item.id, paymentControl })}
                                            >
                                                <p>Abrir</p>
                                            </button>
                                        </td>
                                        <td className={styles.tableData}>{formatName(item.name)}</td>
                                        <td className={styles.tableData}>{item.email}</td>
                                        <td className={styles.tableData}>{item.document ?? 'Sem dados'}</td>
                                        <td className={styles.tableData}>{item.phone}</td>
                                        <td className={styles.tableData} style={trialStatus}>{trialStatus.text}</td>
                                        <td className={styles.tableData} style={paymentStatus}>{paymentStatus.text}</td>
                                        <td className={styles.tableData} style={{ backgroundColor: overdue ? "red" : "transparent", color: overdue ? "#fff" : "#000" }}>{nextPayment}</td>
                                        <td className={styles.tableData}>{new Date(item.created_at).toLocaleDateString()}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}

            </div>
        );
    } else {
        return (
            <div className={styles.listMobile}>
                {clients.map((item) => {
                    const paymentControl = item.payment_control ?? null;
                    const nextPayment = paymentControl?.next_payment
                        ? new Date(paymentControl.next_payment).toLocaleDateString()
                        : "Sem dados";

                    return (
                        <div key={item.id} className={styles.mobileCard}>
                            <h3>{item.name}</h3>
                            
                            <p className={styles.dataText}>Email: {item.email}</p>
                            <p className={styles.dataText}>CPF: {item.document ?? 'Sem dados'}</p>
                            <p className={styles.dataText}>Telefone: {item.phone}</p>
                            <p className={styles.dataText}>Próx Pagamento: {nextPayment}</p>

                            <button
                                className={styles.mobileOpenButton}
                                onClick={() => openUser({ id: item.id, paymentControl })}
                            >
                                Abrir
                            </button>
                        </div>
                    );
                })}
            </div>
        )
    }
}
